import {Component, ChangeDetectionStrategy, Input, OnChanges} from '@angular/core';

@Component({
  selector: 'lke-id',
  template: `<span class="id_block" [style.color]="trueColor">#{{ id }}</span>
`,
  styles: [`.id_block{font-style:italic;white-space:nowrap}`],
  changeDetection : ChangeDetectionStrategy.OnPush
})
export class IdComponent implements OnChanges{

  @Input() id: string|number;
  @Input() color: string|{[key: string]: string};

  public trueColor: string;

  constructor () {}

  public ngOnChanges() {
    this.trueColor = this.generateColor();
  }

  private generateColor(): string {
    if (this.color) {
      return this.getColor();
    } else {
      return "#ccc";
    }
  }

  private getColor(): string {
    if ( typeof this.color === 'object' && !Array.isArray(this.color) ) {
      return Object.keys(this.color).reduce((r, c) => ( this.color[c] ) ? c : r, undefined);
    }
    return this.color as string;
  }
}
